import React from 'react';
import { Responsive } from 'common/lazy';

const TABLET_MAX_WIDTH = 1128;

export default class TabletAndMobileOnly extends React.Component {
  render() {
    return <Responsive maxWidth={TABLET_MAX_WIDTH - 1} {...this.props} />;
  }
}
